<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style >
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0px;
  padding: 0px;
}
body{
    margin: 0px;
  padding: 0px;
}
html{
  margin: 0px;
  padding: 0px;
}
  .van-button__text{
    color: #000;

  }
</style>



// WEBPACK FOOTER //
// src/App.vue